module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion",
    class: (_vm.isOpen ? 'current' : '')
  }, [_c('div', {
    staticClass: "accordion-header"
  }, [_vm._t("header"), _vm._v(" "), _c('i', {
    staticClass: "open-accordion",
    class: _vm.iconClass,
    attrs: {
      "data-toggle": "tooltip",
      "title": "Expandir / Diminuir"
    },
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "accordion-content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-365a9306!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion/accordion.vue
// module id = 2092
// module chunks = 1